import { Link } from "react-router-dom";

interface Props {
  period: string;
}

const InvoicesItem = ({ period }: Props) => {
  return (
    <div className="w-full text-black border-b-2 border-gray-300 p-2 flex items-center text-sm hover:bg-gray-50">
      <p className="w-[8vw]  pr-[2%]">{period}</p>
      <Link to={`/invoice/${period}`} className="ml-auto mr-[2vw]">
        <button className="transition-transform duration-300 ease-in-out text-white bg-gradient-to-r from-[#4bbfed] to-[#008fc7] rounded-[100px] text-[1.5vh] w-[10vw] h-[3vh] cursor-pointer">
          Bekijk
        </button>
      </Link>
    </div>
  );
};

export default InvoicesItem;
